import { ShopifyInstance, ShopifyInstanceIdentifierEnum } from '@repo/shopify/config'

type ElevarKey = Readonly<string>

const elevarShopifyInstanceToKeyMap: Record<ShopifyInstanceIdentifierEnum, ElevarKey> = {
  [ShopifyInstanceIdentifierEnum.EUR]: process.env.NEXT_PUBLIC_ELEVAR_KEY_EUR || '',
  [ShopifyInstanceIdentifierEnum.GBP]: process.env.NEXT_PUBLIC_ELEVAR_KEY_GBP || '',
  [ShopifyInstanceIdentifierEnum.USD]: process.env.NEXT_PUBLIC_ELEVAR_KEY_USD || '',
}

/**
 * Elevar 'non Shopify subdomains' script for headless.
 *
 * @see https://app.getelevar.com
 * @see https://www.toptal.com/developers/javascript-minifier
 */
export const elevarScript = (shopifyInstance: ShopifyInstance): Readonly<string> => {
  const key = elevarShopifyInstanceToKeyMap?.[shopifyInstance.id] || elevarShopifyInstanceToKeyMap[ShopifyInstanceIdentifierEnum.EUR]

  return `const settings={},config=(await import("https://shopify-gtm-suite.getelevar.com/configs/${key}/config.js")).default,scriptUrl=settings.proxyPath?settings.proxyPath+config.script_src_custom_pages_proxied:config.script_src_custom_pages;if(scriptUrl){let{handler:t}=await import(scriptUrl);await t(config,settings)}`
}
